import { SafeLink } from '@/components/ui/SafeLink';
import { CLASSNAME, type CategoryItem } from '@skin-seoul/service';
import { Box, Button, Grid, GridItem, Stack, Text } from '@skin-seoul/design-system';
import NextImage from 'next/image';
type CategorySectionProps = {
  items: CategoryItem[];
  categoryName: string;
  categoryUrl: string;
  onClose?: () => void;
};
const CategorySection = ({
  items,
  categoryName,
  categoryUrl,
  onClose
}: CategorySectionProps) => {
  return <>
      <Box textAlign="center" mb={6} data-sentry-element="Box" data-sentry-source-file="CategorySection.tsx">
        <Text textStyle="label.large" color="generic.100" fontWeight="regular" className={CLASSNAME.NOT_TRANSLATE} data-sentry-element="Text" data-sentry-source-file="CategorySection.tsx">
          {categoryName}
        </Text>
      </Box>
      <Grid templateColumns="repeat(3, 1fr)" rowGap={4} data-sentry-element="Grid" data-sentry-source-file="CategorySection.tsx">
        {items.map(item => <GridItem key={item.name} textAlign="center">
            <SafeLink unstyled href={item.url} onClick={onClose}>
              <Stack gap="20px" direction="column" align="center">
                <Box borderRadius="60px" overflow="hidden" width="60px" height="60px" border="1px solid" borderColor="neutral.100" display="flex" alignItems="center" justifyContent="center">
                  <NextImage src={item.imageUrl ?? ''} alt={item.imageAlt ?? ''} width={60} height={60} style={{
                objectFit: 'contain'
              }} />
                </Box>
                <Text textStyle="label.medium" fontWeight="medium" color="neutral.500" textAlign="center" wordBreak="break-word" className={CLASSNAME.NOT_TRANSLATE}>
                  {item.name}
                </Text>
              </Stack>
            </SafeLink>
          </GridItem>)}
      </Grid>
      <Box textAlign="center" mt={6} mb={4} data-sentry-element="Box" data-sentry-source-file="CategorySection.tsx">
        <Box as="span" width="100%" maxWidth="300px" display="inline-block" data-sentry-element="Box" data-sentry-source-file="CategorySection.tsx">
          <SafeLink href={categoryUrl} unstyled onClick={onClose} data-sentry-element="SafeLink" data-sentry-source-file="CategorySection.tsx">
            <Button variant="outline" width="100%" borderColor="primary.500" color="primary.500" borderRadius="4px" className={CLASSNAME.NOT_TRANSLATE} data-sentry-element="Button" data-sentry-source-file="CategorySection.tsx">
              Shop All from {categoryName}
            </Button>
          </SafeLink>
        </Box>
      </Box>
    </>;
};
export default CategorySection;